/*=====================================
    MemberView

    Author: Ac
    CreateTime: 2018 / 08 / 20
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { GlobalStyle, SideBarStyle, Colors } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoySrefView from 'components/commons/router/CupoySrefView';
import { Route } from "react-router-dom";
import GLOBAL from 'nonnglobal';
import CupoyImage from 'components/commons/CupoyImage';
import { bindActionCreators } from 'redux';
import actionCreators from 'actions/creators';
/**
|--------------------------------------------------
| Variables
|--------------------------------------------------
*/
/*--------------------------
    Styled
--------------------------*/
const MemberDashboard = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 16px;
    border-bottom: 1px solid #D9D9D9;
`;
const MemberInfo = styled.div`
    flex: 1;
    min-width: 0;
`;
const MemberAvatar = styled.div`
    min-width: 45px;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    margin-right: 10px;
    background-color: #E2DFDE;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
`;
const MemberTitle = styled.div`
    color: #4A4A4A;
    font-size: 15px;
    margin-bottom: 4px;
    font-weight: 600;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    word-break: break-all;

    > span {
        font-size: 13px;
        margin-left: 10px;
        white-space: nowrap;
    }
`;
const MemberId = styled.div`
    color: ${Colors.MAIN_COLOR};
    font-size: 13px;
`;
/*--------------------------
    Styled keyframes
--------------------------*/
const SubContainer = GlobalStyle.SubContainer.extend`
    display: flex;
    flex-direction: row;
`;
const MainContent = styled.div`
    flex: 1;
`;
/*--------------------------
    Main Component
--------------------------*/
class MemberView extends Component {

    // static propTypes = {
    // };

    // ------------------------------
    // constructor
    // ------------------------------
    constructor(props) {

        super(props);

        this.lazyLoadComponent = this.lazyLoadComponent.bind(this);

        this.state = {
            MemberCardOrderComponent: null,
            MemberCardOrderDetailComponent: null,
            MemberCardOrderDetailListViewComponent: null,
            MemberContactServiceViewComponent: null,
            MemberHistoryRecordViewComponent: null,
            MemberSystemMessageViewComponent: null,
            MemberInvoiceViewComponent: null,
            MemberRefundViewComponent: null,
            MemberBonusViewComponent: null,
            MemberBonusOrderDetailViewComponent: null,
            MemberInfoViewComponent: null,
            MemberVitemOrderViewComponent: null,
            MemberCartViewComponent: null,
            CheckoutViewComponent: null, 
            MemberCartPaymentInfoViewComponent: null,
            MemberComplaintViewComponent: null,
            MemberVitemOrderDetailSaleViewComponent: null,
            MemberVitemOrderDetailPurchaseViewComponent: null,
            MemberCardOrderUnpayDetailViewComponent: null,
            EsunWebATMResultViewComponent: null,
        };

    }

    componentDidMount (){

        window.scrollTo({
            top: 0,
        });
        this.lazyLoadComponent();
        
        const { haslogin } = this.props;

        !haslogin && this.props.webActions.showSignInDialog();

    }

    lazyLoadComponent (){
        import('components/member/MemberCardOrderView').then(MemberCardOrderModule => {
            this.setState({ MemberCardOrderComponent: MemberCardOrderModule.default });
        });
        import('components/member/MemberCardOrderDetailView').then(MemberCardOrderDetailModule => {
            this.setState({ MemberCardOrderDetailComponent: MemberCardOrderDetailModule.default });
        });
        import('components/member/MemberCardOrderDetailListView').then(MemberCardOrderDetailListModule => {
            this.setState({ MemberCardOrderDetailListComponent: MemberCardOrderDetailListModule.default });
        });
        import('components/member/MemberContactServiceView').then(MemberContactServiceModule => {
            this.setState({ MemberContactServiceViewComponent: MemberContactServiceModule.default });
        });
        import('components/member/MemberHistoryRecordView').then(MemberHistoryRecordModule => {
            this.setState({ MemberHistoryRecordViewComponent: MemberHistoryRecordModule.default });
        });
        import('components/member/MemberSystemMessageView').then(MemberSystemMessageModule => {
            this.setState({ MemberSystemMessageViewComponent: MemberSystemMessageModule.default });
        });
        import('components/member/MemberInvoiceView').then(MemberInvoiceModule => {
            this.setState({ MemberInvoiceViewComponent: MemberInvoiceModule.default });
        });
        import('components/member/MemberRefundView').then(MemberRefundModule => {
            this.setState({ MemberRefundViewComponent: MemberRefundModule.default });
        });
        import('components/member/MemberBonusView').then(MemberBonusModule => {
            this.setState({ MemberBonusViewComponent: MemberBonusModule.default });
        });
        import('components/member/MemberBonusOrderDetailView').then(MemberBonusOrderDetailModule => {
            this.setState({ MemberBonusOrderDetailViewComponent: MemberBonusOrderDetailModule.default });
        });
        import('components/member/MemberInfoView').then(MemberInfoModule => {
            this.setState({ MemberInfoViewComponent: MemberInfoModule.default });
        });
        import('components/member/MemberVitemOrderView').then(MemberVitemOrderModule => {
            this.setState({ MemberVitemOrderViewComponent: MemberVitemOrderModule.default });
        });
        import('components/member/MemberCartView').then(MemberCartModule => {
            this.setState({ MemberCartViewComponent: MemberCartModule.default });
        });
        import('components/member/CheckoutView').then(MemberCheckoutModule => {
            this.setState({ CheckoutViewComponent: MemberCheckoutModule.default });
        });
        import('components/member/MemberCartPaymentInfoView').then(MemberCartPaymentInfoModule => {
            this.setState({ MemberCartPaymentInfoViewComponent: MemberCartPaymentInfoModule.default });
        });
        import('components/member/MemberComplaintView').then(MemberComplaintModule => {
            this.setState({ MemberComplaintViewComponent: MemberComplaintModule.default });
        });

        import('components/member/MemberVitemOrderDetailSaleView').then(MemberVitemOrderDetailSaleModule => {
            this.setState({ MemberVitemOrderDetailSaleViewComponent: MemberVitemOrderDetailSaleModule.default });
        });
        import('components/member/MemberVitemOrderDetailPurchaseView').then(MemberVitemOrderDetailPurchaseModule => {
            this.setState({ MemberVitemOrderDetailPurchaseViewComponent: MemberVitemOrderDetailPurchaseModule.default });
        });
        import('components/member/MemberCardOrderUnpayDetailView').then(MemberCardOrderUnpayDetailModule => {
            this.setState({ MemberCardOrderUnpayDetailViewComponent: MemberCardOrderUnpayDetailModule.default });
        });
        import('components/member/EsunWebATMResultView').then(EsunWebATMResultModule => {
            this.setState({ EsunWebATMResultViewComponent: EsunWebATMResultModule.default });
        });

    }
    // ------------------------------
    // render
    // ------------------------------
    render() {

        const { haslogin } = this.props;

        return (
            <SubContainer>
                {this.renderSideBar()}
                <MainContent>
                    {
                        haslogin ?
                        this.renderContent()
                        :
                        this.renderMemberNoLogin()
                    }
                </MainContent>
            </SubContainer>
        );
    }

    renderContent = () => {
        
        const {
            MemberCardOrderComponent,
            MemberCardOrderDetailComponent,
            MemberCardOrderDetailListComponent,
            MemberContactServiceViewComponent,
            MemberHistoryRecordViewComponent,
            MemberSystemMessageViewComponent,
            MemberInvoiceViewComponent,
            MemberRefundViewComponent,
            MemberBonusViewComponent,
            MemberBonusOrderDetailViewComponent,
            MemberInfoViewComponent,
            MemberVitemOrderViewComponent,
            MemberCartViewComponent,
            CheckoutViewComponent,
            MemberCartPaymentInfoViewComponent,
            MemberComplaintViewComponent,
            MemberVitemOrderDetailSaleViewComponent,
            MemberVitemOrderDetailPurchaseViewComponent,
            MemberCardOrderUnpayDetailViewComponent,
            EsunWebATMResultViewComponent,
        } = this.state;

        return (
            <div>
                {MemberCardOrderComponent && <Route path={CupoyRouter.PATHS.MEMBER_CARD_ORDER} component={MemberCardOrderComponent} />}
                {MemberCardOrderDetailComponent && <Route path={CupoyRouter.PATHS.MEMBER_CARD_ORDER_DETAIL} component={MemberCardOrderDetailComponent} exact />}
                {MemberCardOrderDetailListComponent && <Route path={CupoyRouter.PATHS.MEMBER_CARD_ORDER_DETAIL_LIST} component={MemberCardOrderDetailListComponent} exact />}
                {MemberContactServiceViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_CONTACT_SERVICE} component={MemberContactServiceViewComponent} />}
                {MemberHistoryRecordViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_HISTORY_RECORD} component={MemberHistoryRecordViewComponent} exact />}
                {MemberSystemMessageViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_SYSTEM_MESSAGE} component={MemberSystemMessageViewComponent} exact />}
                {MemberInvoiceViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_INVOICE} component={MemberInvoiceViewComponent} exact />}
                {MemberRefundViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_REFUND} component={MemberRefundViewComponent} />}
                {MemberBonusViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_BONUS} component={MemberBonusViewComponent} />}
                {MemberBonusOrderDetailViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_BONUS_ORDER_DETAIL} component={MemberBonusOrderDetailViewComponent} exact />}
                {MemberInfoViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_INFO} component={MemberInfoViewComponent} exact />}
                {MemberVitemOrderViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_VITEM_ORDER} component={MemberVitemOrderViewComponent} />}
                {MemberCartViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_CART} component={MemberCartViewComponent} exact />}
                {CheckoutViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_CHECKOUT} component={CheckoutViewComponent} exact />}
                {MemberCartPaymentInfoViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_CART_PAYMENT_INFO} component={MemberCartPaymentInfoViewComponent} exact />}
                {MemberComplaintViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_COMPLAINT} component={MemberComplaintViewComponent} exact />}
                {MemberVitemOrderDetailSaleViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_VITEM_ORDER_DETAIL_SALE} component={MemberVitemOrderDetailSaleViewComponent} exact />}
                {MemberVitemOrderDetailPurchaseViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_VITEM_ORDER_DETAIL_PURCHASE} component={MemberVitemOrderDetailPurchaseViewComponent} exact />}
                {MemberCardOrderUnpayDetailViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_CARD_ORDER_UNPAY_DETAIL} component={MemberCardOrderUnpayDetailViewComponent} exact />}
                {EsunWebATMResultViewComponent && <Route path={CupoyRouter.PATHS.MEMBER_ESUN_WEB_ATM_RESULT} component={EsunWebATMResultViewComponent} exact />}
            </div>
        );
    }
    
    renderSideBar = () => {

        const {
            haslogin,
            memberinfo,
        } = this.props;

        const {
            mrscid,
            membername = '',
            nickname = '',
            shownametype,
            isvip,
        } = memberinfo;

        const memerAvatarRsc = GLOBAL.getMemberAvatarRsc(memberinfo);

        return (
            <SideBarStyle.Container>
                <SideBarStyle.Section>
                    {haslogin && (
                        <MemberDashboard>
                            <CupoySrefView statename={CupoyRouter.STATES.HELP_UPGRADE_MEMBERSHIP}>
                                <CupoyImage
                                    stylecomponent={MemberAvatar}
                                    src={memerAvatarRsc}
                                    isBackgroundImage
                                />
                            </CupoySrefView>
                            <MemberInfo>
                                <MemberTitle>
                                    {shownametype === 1
                                        ? membername.trim()
                                        : nickname.trim()
                                    }
                                    {isvip
                                        ? <span>VIP會員</span>
                                        : <span>正式會員</span>
                                    }
                                </MemberTitle>
                                <MemberId>{`No.${mrscid}`}</MemberId>
                            </MemberInfo>
                        </MemberDashboard>
                    )}
                    <SideBarStyle.SectionTitle>
                        訂單管理
                        <SideBarStyle.SpreadIcon>
                            <i className="zmdi zmdi-caret-down"></i>
                        </SideBarStyle.SpreadIcon>
                    </SideBarStyle.SectionTitle>

                    <SideBarStyle.Nav>
                        <SideBarStyle.NavItem isActive={CupoyRouter.isActive(CupoyRouter.STATES.MEMBER_CART)}>
                            <CupoySrefView
                                statename={CupoyRouter.STATES.MEMBER_CART}
                                stylecomponent={SideBarStyle.NavItemContent}
                            >
                                <SideBarStyle.NavItemLinearGradientIcon
                                    size={14}
                                    linearGradient='-135deg, #3DD283 0%, #89F3B9 100%'
                                >
                                    <i className="zmdi zmdi-shopping-cart"></i>
                                </SideBarStyle.NavItemLinearGradientIcon>
                                <SideBarStyle.NavItemText>購物車</SideBarStyle.NavItemText>
                            </CupoySrefView>
                        </SideBarStyle.NavItem>

                        <SideBarStyle.NavItem
                            isActive={
                                CupoyRouter.includes(CupoyRouter.STATES.MEMBER_CARD_ORDER) ||
                                CupoyRouter.isActive(CupoyRouter.STATES.MEMBER_CARD_ORDER_DETAIL_LIST) ||
                                CupoyRouter.isActive(CupoyRouter.STATES.MEMBER_CARD_ORDER_DETAIL)                            
                            }
                        >
                            <CupoySrefView
                                statename={CupoyRouter.STATES.MEMBER_CARD_ORDER_LIST_FINISH}
                                stylecomponent={SideBarStyle.NavItemContent}
                            >
                                <SideBarStyle.NavItemLinearGradientIcon
                                    size={14}
                                    linearGradient='-135deg, #00D4B7 0%, #60EFD8 100%'
                                >
                                    <i className="zmdi zmdi-card-giftcard"></i>
                                </SideBarStyle.NavItemLinearGradientIcon>
                                <SideBarStyle.NavItemText>點卡產包</SideBarStyle.NavItemText>
                            </CupoySrefView>
                        </SideBarStyle.NavItem>
                        {/* <SideBarStyle.NavItem isActive={CupoyRouter.includes(CupoyRouter.STATES.MEMBER_VITEM_ORDER)}>
                            <CupoySrefView
                                statename={CupoyRouter.STATES.MEMBER_VITEM_ORDER_SALE}
                                stylecomponent={SideBarStyle.NavItemContent}
                            >
                                <SideBarStyle.NavItemLinearGradientIcon
                                    size={14}
                                    linearGradient='-135deg, #00BCD4 0%, #60E0F0 100%'
                                >
                                    <i className="zmdi zmdi-balance"></i>
                                </SideBarStyle.NavItemLinearGradientIcon>
                                <SideBarStyle.NavItemText>虛寶市集</SideBarStyle.NavItemText>
                            </CupoySrefView>
                        </SideBarStyle.NavItem> */}
                    </SideBarStyle.Nav>
                </SideBarStyle.Section>
                <SideBarStyle.Section>
                    <SideBarStyle.SectionTitle>
                        帳戶管理
                        <SideBarStyle.SpreadIcon>
                            <i className="zmdi zmdi-caret-down"></i>
                        </SideBarStyle.SpreadIcon>
                    </SideBarStyle.SectionTitle>
                    <SideBarStyle.Nav>
                        {/* <SideBarStyle.NavItem>
                            <SideBarStyle.NavItemContent>
                                <SideBarStyle.NavItemLinearGradientIcon
                                    size={14}
                                    linearGradient='-135deg, #F76B1C 0%, #FAC261 100%'
                                >
                                    <i className="zmdi zmdi-star"></i>
                                </SideBarStyle.NavItemLinearGradientIcon>
                                <SideBarStyle.NavItemText>常用商品</SideBarStyle.NavItemText>
                            </SideBarStyle.NavItemContent>
                        </SideBarStyle.NavItem> */}
                        <SideBarStyle.NavItem isActive={CupoyRouter.includes(CupoyRouter.STATES.MEMBER_BONUS)}>
                            <CupoySrefView
                                statename={CupoyRouter.STATES.MEMBER_BONUS_LOGS}
                                stylecomponent={SideBarStyle.NavItemContent}
                            >
                                <SideBarStyle.NavItemLinearGradientIcon
                                    size={16}
                                    linearGradient='-135deg, #F7451C 0%, #FAAA61 100%'
                                >
                                    <i className="zmdi zmdi-money"></i>
                                </SideBarStyle.NavItemLinearGradientIcon>
                                <SideBarStyle.NavItemText>我的發財金</SideBarStyle.NavItemText>
                            </CupoySrefView>
                        </SideBarStyle.NavItem>
                        <SideBarStyle.NavItem isActive={CupoyRouter.includes(CupoyRouter.STATES.MEMBER_REFUND)}>
                            <CupoySrefView
                                statename={CupoyRouter.STATES.MEMBER_REFUND_APPLY}
                                stylecomponent={SideBarStyle.NavItemContent}
                            >
                                <SideBarStyle.NavItemLinearGradientIcon
                                    size={16}
                                    linearGradient='-135deg, #FF338D 0%, #FF94C4 100%'
                                >
                                    <i className="zmdi zmdi-money"></i>
                                </SideBarStyle.NavItemLinearGradientIcon>
                                <SideBarStyle.NavItemText>帳戶退款</SideBarStyle.NavItemText>
                            </CupoySrefView>
                        </SideBarStyle.NavItem>
                        <SideBarStyle.NavItem isActive={CupoyRouter.isActive(CupoyRouter.STATES.MEMBER_INVOICE)}>
                            <CupoySrefView
                                statename={CupoyRouter.STATES.MEMBER_INVOICE}
                                stylecomponent={SideBarStyle.NavItemContent}
                            >
                                <SideBarStyle.NavItemLinearGradientIcon
                                    size={14}
                                    linearGradient='-135deg, #008AFF 0%, #84D1F3 100%'
                                >
                                    <i className="zmdi zmdi-ticket-star"></i>
                                </SideBarStyle.NavItemLinearGradientIcon>
                                <SideBarStyle.NavItemText>發票管理</SideBarStyle.NavItemText>
                            </CupoySrefView>
                        </SideBarStyle.NavItem>
                        <SideBarStyle.NavItem isActive={CupoyRouter.isActive(CupoyRouter.STATES.MEMBER_SYSTEM_MESSAGE)}>
                            <CupoySrefView
                                statename={CupoyRouter.STATES.MEMBER_SYSTEM_MESSAGE}
                                stylecomponent={SideBarStyle.NavItemContent}
                            >
                                <SideBarStyle.NavItemLinearGradientIcon
                                    size={14}
                                    linearGradient='-135deg, #9E9E9E 0%, #C6C6C6 100%'
                                >
                                    <i className="zmdi zmdi-notifications"></i>
                                </SideBarStyle.NavItemLinearGradientIcon>
                                <SideBarStyle.NavItemText>系統訊息</SideBarStyle.NavItemText>
                            </CupoySrefView>
                        </SideBarStyle.NavItem>
                        <SideBarStyle.NavItem isActive={CupoyRouter.isActive(CupoyRouter.STATES.MEMBER_HISTORY_RECORD)}>
                            <CupoySrefView
                                statename={CupoyRouter.STATES.MEMBER_HISTORY_RECORD}
                                stylecomponent={SideBarStyle.NavItemContent}
                            >
                                <SideBarStyle.NavItemLinearGradientIcon
                                    size={13}
                                    linearGradient='-135deg, #9E9E9E 0%, #C6C6C6 100%'
                                >
                                    <i className="zmdi zmdi-folder"></i>
                                </SideBarStyle.NavItemLinearGradientIcon>
                                <SideBarStyle.NavItemText>歷程紀錄</SideBarStyle.NavItemText>
                            </CupoySrefView>
                        </SideBarStyle.NavItem>
                    </SideBarStyle.Nav>
                </SideBarStyle.Section>
                <SideBarStyle.Section>
                    <SideBarStyle.SectionTitle>
                        修改資料
                        <SideBarStyle.SpreadIcon>
                            <i className="zmdi zmdi-caret-down"></i>
                        </SideBarStyle.SpreadIcon>
                    </SideBarStyle.SectionTitle>
                    <SideBarStyle.Nav>
                        <SideBarStyle.NavItem isActive={CupoyRouter.isActive(CupoyRouter.STATES.MEMBER_INFO)}>
                            <CupoySrefView
                                statename={CupoyRouter.STATES.MEMBER_INFO}
                                stylecomponent={SideBarStyle.NavItemContent}
                            >
                                <SideBarStyle.NavItemLinearGradientIcon
                                    size={17}
                                    linearGradient='-135deg, #9237E2 0%, #BA94EA 100%'
                                >
                                    <i className="zmdi zmdi-account"></i>
                                </SideBarStyle.NavItemLinearGradientIcon>
                                <SideBarStyle.NavItemText>會員資料</SideBarStyle.NavItemText>
                            </CupoySrefView>
                        </SideBarStyle.NavItem>

                        {/* <SideBarStyle.NavItem isActive={CupoyRouter.isActive(CupoyRouter.STATES.RESET_PWD)}>
                            <CupoySrefView
                                statename={CupoyRouter.STATES.RESET_PWD}
                                stylecomponent={SideBarStyle.NavItemContent}
                            >
                                <SideBarStyle.NavItemLinearGradientIcon
                                    size={13}
                                    linearGradient='-135deg, #BC2CB8 0%, #DC8DE6 100%'
                                >
                                    <i className="zmdi zmdi-lock"></i>
                                </SideBarStyle.NavItemLinearGradientIcon>
                                <SideBarStyle.NavItemText>帳號密碼</SideBarStyle.NavItemText>
                            </CupoySrefView>
                        </SideBarStyle.NavItem> */}
                    </SideBarStyle.Nav>
                </SideBarStyle.Section>
                <SideBarStyle.Section>
                    <SideBarStyle.SectionTitle>
                        聯繫我們
                        <SideBarStyle.SpreadIcon>
                            <i className="zmdi zmdi-caret-down"></i>
                        </SideBarStyle.SpreadIcon>
                    </SideBarStyle.SectionTitle>
                    <SideBarStyle.Nav>
                        <SideBarStyle.NavItem
                            isActive={
                                CupoyRouter.includes(CupoyRouter.STATES.MEMBER_CONTACT_SERVICE) ||
                                CupoyRouter.isActive(CupoyRouter.STATES.MEMBER_COMPLAINT)
                            }
                        >
                            <CupoySrefView
                                statename={CupoyRouter.STATES.MEMBER_CONTACT_SERVICE_ADD_COMPLAINT}
                                stylecomponent={SideBarStyle.NavItemContent}
                            >
                                <SideBarStyle.NavItemLinearGradientIcon
                                    size={13}
                                    linearGradient='-135deg, #4D5AE1 0%, #8BABFF 100%'
                                >
                                    <i className="zmdi zmdi-email"></i>
                                </SideBarStyle.NavItemLinearGradientIcon>
                                <SideBarStyle.NavItemText>會員客訴</SideBarStyle.NavItemText>
                            </CupoySrefView>
                        </SideBarStyle.NavItem>
                    </SideBarStyle.Nav>
                </SideBarStyle.Section>
            </SideBarStyle.Container>
        );
    }

    renderMemberNoLogin = () => {
        return (
            <GlobalStyle.BasicBlock>
                <GlobalStyle.ErrorContainer>
                    <GlobalStyle.ErrorContainerTitle>您尚未登入</GlobalStyle.ErrorContainerTitle>
                    <GlobalStyle.ErrorContainerDesription>您尚未登入，請登入後再重新操作一次。</GlobalStyle.ErrorContainerDesription>
                </GlobalStyle.ErrorContainer>
            </GlobalStyle.BasicBlock>
        );
    }

}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        haslogin: state.member.haslogin,
        memberinfo: state.member.memberinfo,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(MemberView);